<template>
  <div class="button-wrap">
    <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增按钮</el-button>

    <!-- 按钮列表表格 -->
    <el-table :data="tableData" border class="mt-20" style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="buttonName" label="按钮名称" align="center" />
      <el-table-column prop="buttonCode" label="按钮编码" align="center" />
      <el-table-column prop="remark" label="备注" align="center" />
      <el-table-column prop="createTime" label="创建时间" align="center" />
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="props">
          <el-button type="text" v-if="props.row.status!=10" icon="el-icon-edit" @click="openEditDialog(props.row)">编辑</el-button>
          <el-button type="text"  v-if="props.row.status!=10" icon="el-icon-delete" @click="handleDelete(props.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑弹窗 -->
    <el-dialog title="按钮信息" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="按钮名称">
          <el-input v-model="form.buttonName"></el-input>
        </el-form-item>
        <el-form-item label="按钮编码">
          <el-input v-model="form.buttonCode"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { btnList, addBtn, updateBtn, delBtn } from './memu.js'
export default {
  name: 'ButtonTable',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: {
        id: null,
        buttonName: '',
        buttonCode: '',
        remark: '',
		status:1,
      }
    }
  },
  mounted() {
    this.loadTableData()
  },
  methods: {
    // 加载列表
    async loadTableData() {
      const res = await btnList()
      this.tableData = res.data.data
    },
    // 新增
    openAddDialog() {
      this.dialogVisible = true
      this.form = { id: null, buttonName: '', buttonCode: '', remark: '',status:1 }
    },
    // 编辑
    openEditDialog(row) {
      this.dialogVisible = true
      this.form = { ...row }
    },
    // 提交
    async submitForm() {
      try {
        if (this.form.id) {
          await updateBtn(this.form)
          this.$message.success('编辑成功')
        } else {
          await addBtn(this.form)
          this.$message.success('新增成功')
        }
        this.dialogVisible = false
        this.loadTableData()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确定删除该按钮？', '提示', { type: 'warning' })
        .then(async () => {
          await delBtn(row.id)
          this.$message.success('删除成功')
          this.loadTableData()
        })
    }
  }
}
</script>

<style scoped>
.mt-20 {
  margin-top: 20px;
}
</style>